import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  productName: EMPTY_STRING,
  productReference: null,
  collectiveProduct: null,
  collectiveProductExist: null,
};
